import { ConstantValues } from "common/constants";
import * as XLSX from "xlsx";

export const normalizeHeader = (header: string): string =>
  header.replace(/\s+/g, " ").trim();

export const deduplicateHeaders = (headers: string[]): string[] => {
  const emitted = new Set<string>();
  return headers.map((header) => {
    let candidate = header;
    let count = 1;
    while (emitted.has(candidate)) {
      count += 1;
      candidate = `${header} (${count})`;
    }
    emitted.add(candidate);
    return candidate;
  });
};

export const parseCSVColumns = (
  content: string,
  delimiter: string,
): string[] => {
  const lines = content.split("\n");
  if (lines.length === 0) return [];
  const firstLine = lines[0].replace(/\r$/, ConstantValues.EMPTY_STRING);
  const normalized = firstLine
    .split(delimiter)
    .map((col) =>
      normalizeHeader(col.replace(/^"|"$/g, ConstantValues.EMPTY_STRING)),
    )
    .filter(Boolean);
  return deduplicateHeaders(normalized);
};

export const parseXLSXColumns = async (
  file: File,
  sheetName?: string,
): Promise<string[]> => {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const targetSheet = workbook.Sheets[sheetName ?? workbook.SheetNames[0]];
  if (!targetSheet) return [];
  const rows = XLSX.utils.sheet_to_json<string[]>(targetSheet, { header: 1 });
  if (rows.length === 0) return [];
  const normalized = (rows[0] as (string | number | null)[])
    .map((col) => normalizeHeader(String(col ?? "")))
    .filter(Boolean);
  return deduplicateHeaders(normalized);
};
